import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=856e3f4c&"
import script from "./testPaper.vue?vue&type=script&lang=ts&"
export * from "./testPaper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports